import { IChartData } from "@/models/Charts/ChartData";
import { WorkInProgress } from "@/services/api";
import * as React from "react";
import { BarChart } from "../../molecules/Charts/BarChart";
import _ from "lodash";
import Rand from "rand-seed";

export interface IProductionStatusCountProps {
	wipItems: WorkInProgress[];
	loading?: boolean;
}

export function ProductionStatusCount({ wipItems, loading }: IProductionStatusCountProps) {
	const chartData = React.useMemo<IChartData>(() => {
		if (loading) {
			const labels = Array.from(Array(5).keys()).map((i, index) => {
				return "Status " + (i + 1);
			});
			const rand = new Rand("submitted");
			const cd: IChartData = {
				key: "loading-data",
				items: [
					{
						values: labels.map((i) => Math.round(rand.next() * 10)),
						color: "#eee",
					},
				],
				labels,
			};

			return cd;
		}

		const insuranceCompanies = _.uniq(wipItems.map((i) => i.productionStatus ?? "(Empty)")).sort();

		const cd: IChartData = {
			items: [
				{
					values: insuranceCompanies.map<number>(
						(i) => wipItems.filter((j) => (j.productionStatus ?? "(Empty)") === i).length
					),
				},
			],
			labels: insuranceCompanies,
		};

		return cd;
	}, [wipItems, loading]);

	return <BarChart title="WIP by Production Status" data={chartData} horizontal />;
}
